<template>
  <b-modal v-model="displayModal" centered hide-footer hide-header @hidden="onReset">
    <div class="violations-create-modal">
      <svg
        class="violations-create-modal__close-icon"
        width="15"
        height="16"
        viewBox="0 0 15 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        @click="onReset"
      >
        <path
          d="M10.6045 11.5377C10.2154 11.9267 9.58272 11.9247 9.19126 11.5333L3.53712 5.88051C3.14565 5.48904 3.14367 4.85633 3.5327 4.4673C3.92172 4.07828 4.55443 4.08026 4.9459 4.47173L10.6 10.1245C10.9915 10.5159 10.9935 11.1486 10.6045 11.5377Z"
          fill="#8E9CBB"
        />
        <path
          d="M10.6127 4.47053C10.2212 4.07907 9.58849 4.07709 9.19947 4.46611L3.53718 10.1284C3.14816 10.5174 3.15014 11.1501 3.54161 11.5416C3.93307 11.9331 4.56579 11.9351 4.95481 11.546L10.6171 5.88374C11.0061 5.49471 11.0041 4.862 10.6127 4.47053Z"
          fill="#8E9CBB"
        />
      </svg>

      <div class="violations-create-modal__title">Редактирование нарушения</div>
      <div class="violations-create-modal__row">
        <div class="violations-create-modal__item date-input">
          <c-input
            v-model="form.date"
            type="date"
            placeholder="00.00.0000"
            label="Дата нарушения"
            :icon-right="true"
            icon="calendar"
            :clearable="true"
            :class="{ 'required-field': errorMessages.date }"
            :required="errorMessages.date"
            :required-condition="errorMessages.date"
          />
        </div>
      </div>

      <div class="violations-create-modal__row">
        <div class="violations-create-modal__item mb-0">
          <c-select
            v-model="form.violation"
            class="violation-filter violation-filter__violations"
            label="Тип нарушения"
            placeholder="Все"
            :groups="collections.foulTypes.groups"
            :items="collections.foulTypes.items"
            :searchable="true"
            :clearable="true"
            :class="{ 'required-field': errorMessages.violation }"
            :required="errorMessages.violation"
            :required-condition="errorMessages.violation"
          />

          <show-description :value="form.violation && form.violation.descriptionModel" />
        </div>
      </div>

      <div class="violations-create-modal__actions">
        <responsive-apply-reset-actions
          :fixed="false"
          :disabled-but-clickable-submit="isSubmitDisabled"
          @on-submit="onSubmit"
          @on-reset="onReset"
        />
      </div>
    </div>
  </b-modal>
</template>

<script>
import { mapState } from "vuex";
import Input from "@/components/controls2/Input";
import Select from "@/components/controls2/Select";
import ResponsiveApplyResetActions from "@/components/responsive-apply-reset-actions";
import ShowDescription from "@/components/show-description";

export default {
  name: "create-modal",
  components: {
    "c-input": Input,
    "c-select": Select,
    ResponsiveApplyResetActions,
    ShowDescription,
  },
  data() {
    return {
      displayModal: false,
      id: null,
      isPending: false,
      form: {
        date: "",

        violation: null,
      },
      errorMessages: {
        date: "",

        violation: "",
      },
    };
  },
  computed: {
    ...mapState({
      collections: (state) => state.violations.collections,
    }),

    isSubmitDisabled() {
      return !this.form.date || !this.form.violation;
    },
  },
  watch: {
    "form.date": function (value) {
      if (value && this.errorMessages.date) {
        this.errorMessages.date = "";
      }
    },
    "form.violation": function (value) {
      if (value && this.errorMessages.violation) {
        this.errorMessages.violation = "";
      }
    },
  },
  methods: {
    validate() {
      let isValid = true;
      if (!this.form.date) {
        isValid = false;
        this.errorMessages.date = "Обязательное поле";
      }
      if (!this.form.violation) {
        isValid = false;
        this.errorMessages.violation = "Обязательное поле";
      }

      return isValid;
    },
    async onSubmit() {
      if (this.isPending) {
        return;
      }

      if (!this.validate()) {
        return;
      }

      this.isPending = true;

      const { success } = await this.$store.dispatch("violations/updateViolation", { ...this.form, id: this.id });
      if (success) {
        this.onReset();
        this.isPending = false;
      }
    },
    onReset() {
      this.form.date = "";
      this.form.violation = null;
      this.errorMessages.date = "";
      this.errorMessages.violation = "";
      this.id = null;
      this.displayModal = false;
    },
    open(data = {}) {
      this.id = data.id;

      this.form.date = data.date.value;
      this.form.violation = this.collections.foulTypes.items.find(
        (type) => type.value.toString() === data.foul.id.toString(),
      );

      this.displayModal = true;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/vars.scss";

.violations-create-modal {
  &__close-icon {
    position: absolute;
    top: 10px;
    right: 10px;
  }
  &__title {
    font-size: 18px;
    font-weight: 500;
    margin-bottom: 20px;

    @include onlyExtraSmall {
      font-size: 15px;
    }
  }
  &__row {
    display: flex;
    gap: 30px;
    @include onlyStandartMobile {
      flex-wrap: wrap;
    }
  }
  &__item {
    flex-grow: 1;
    max-width: 100%;
    margin-bottom: 25px;

    @include onlyExtraSmall {
      width: 100%;
    }
    &.date-input {
      flex-grow: 0;
      width: 125px;

      @include onlyExtraSmall {
        width: 133px;
      }
    }
  }
  &__actions {
    display: flex;
    justify-content: flex-end;
    @include onlyExtraSmall {
      margin-right: -20px;
    }
  }
}
.mb-0 {
  margin-bottom: 0;
}
@include onlyStandartMobile {
  ::v-deep .modal-content {
    height: auto;
  }
  ::v-deep .modal-body {
    padding-bottom: 0;
  }
}
.required-field {
  margin-bottom: 20px;
}
</style>
